<div class="container-fluid">
	<!-- Section 1 -->
	<div class="row" *ngIf="stats_data && stats_data.length > 0">
	  <div class="col-xl-3 col-lg-6 col-12" *ngFor="let stat of stats_data">
		<div class="card">
		  <div class="card-content">
			<div class="card-body stats">
			  <div class="media"> 
				<div class="media-body text-left">
				  <h3 class="mb-1 primary">{{ stat.value }}</h3>
				  <span>{{ stat.label }}</span>
				</div>
				<div class="media-right align-self-center">
				  <i *ngIf="stat.label === 'Year Experience'" class="ft-briefcase primary font-large-2 float-right"></i>
				  <img *ngIf="stat.label === 'Employees'"  src="../../../assets/employees.svg" width="65" alt="employee-img">
				  <img *ngIf="stat.label === 'Products Developed'"  src="../../../assets/products.svg" width="55" alt="products-img">
				  <img *ngIf="stat.label === 'Projects Completed'"  src="../../../assets/project-complete.svg" width="43" alt="project-complete-img">
				</div>
			  </div>
			</div>
		  </div>
		</div>
	  </div>
	</div>
	<!-- Section 2 -->
	<div class="row" *ngIf="hot_links && hot_links.length > 0">
		<div class="col-9 card-body section2">
		  <button
		  *ngFor="let link of hot_links"
		  type="button"
		  class="btn bg-light-primary mr-1 custom-icon mb-1 mb-lg-0"
		  (click)="gotoLink(link.url)"
		>
		  {{ link.linkName }}
		</button>
		</div>
		<div class="col-3 d-flex justify-content-end align-items-center">
		  <button  class="btn btn-secondary mr-1 custom-icon mb-1 mb-lg-0" (click)="openModal(taskModal)">My Tasks</button>
		</div>
		
	</div>
	<!-- Section 2A -->
	  <div class="col-12 section2A" *ngIf="general_info && showAlert">
		  <div *ngFor="let item of general_info" class="mb-2">
			<ngb-alert
			  type="primary"
			  (click)="closeAlert(item); showAlert = false"
			>
			  {{ item?.description }}
			</ngb-alert>
		  </div>
	  </div>
  
	<!-- Section 3 -->
	  <div class="col-12" *ngIf="quick_links && quick_links.length > 0">
		<button
		  *ngFor="let links of quick_links; let i = index"
		  type="button"
		  [ngClass]="getRandomClass(i)"
		  (click)="gotoLink(links.url)"
		>
		  {{ links.linkName }}
		</button>
	  </div>
	<!-- section 3A -->
	  <div class="col-12 warn-msg" *ngIf="warn_message">
		<div class="card-content">
		  <div class="card-body">
			<div *ngIf="warn_message?.description" class="mb-2">
			  <ngb-alert type="warning">{{
				warn_message?.description
			  }}</ngb-alert>
			</div>
		  </div>
		</div>
	  </div>
	<!-- Section 4 -->
	<div class="row section-guide">
	  <div #dynamicContainer></div>
	</div>
	<!-- Section 5 -->
	<div class="row section-guide">
	  <div #todayThoughtContainer></div>
	</div>
	<!-- Section 6 -->
	<div class="row">
	  <div class="col-xl-3 col-lg-6 col-md-6 col-12">
		<div class="card gradient-purple-love">
		  <div class="card-content">
			<div class="card-body py-0">
			  <div class="media pb-1">
				<div class="media-body white text-left">
				  <h3 class="font-large-1 white mb-0">
					{{ usersLength }}
				  </h3>
				  <span>Total Users</span>
				</div>
				<!-- <div class="media-right white text-right">
					  <i class="ft-activity font-large-1"></i>
					</div> -->
			  </div>
			</div>
			<div
			  id="Widget-line-chart"
			  class="WidgetlineChart WidgetlineChartshadow mb-2"
			>
			  <x-chartist
				class="height-75"
				[type]="WidgetlineChart.type"
				[options]="WidgetlineChart.options"
				[responsiveOptions]="WidgetlineChart.responsiveOptions"
				[events]="WidgetlineChart.events"
			  >
			  </x-chartist>
			</div>
		  </div>
		</div>
	  </div>
	  <div class="col-xl-3 col-lg-6 col-md-6 col-12">
		<div class="card gradient-ibiza-sunset">
		  <div class="card-content">
			<div class="card-body py-0">
			  <div class="media pb-1">
				<div class="media-body white text-left">
				  <h3 class="font-large-1 white mb-0">
					{{ studentLength }}
				  </h3>
				  <span>Total Students</span>
				</div>
				<!-- <div class="media-right white text-right">
					  <i class="ft-percent font-large-1"></i>
					</div> -->
			  </div>
			</div>
			<div
			  id="Widget-line-chart"
			  class="WidgetlineChart WidgetlineChartshadow mb-2"
			>
			  <x-chartist
				class="height-75"
				[type]="WidgetlineChart1.type"
				[options]="WidgetlineChart1.options"
				[responsiveOptions]="WidgetlineChart1.responsiveOptions"
				[events]="WidgetlineChart1.events"
			  >
			  </x-chartist>
			</div>
		  </div>
		</div>
	  </div>
  
	  <div class="col-xl-3 col-lg-6 col-md-6 col-12">
		<div class="card gradient-mint">
		  <div class="card-content">
			<div class="card-body py-0">
			  <div class="media pb-1">
				<div class="media-body white text-left">
				  <h3 class="font-large-1 white mb-0">{{ businessLength }}</h3>
				  <span> Total Business</span>
				</div>
				<!-- <div class="media-right white text-right">
					  <i class="ft-trending-up font-large-1"></i>
					</div> -->
			  </div>
			</div>
			<div
			  id="Widget-line-chart"
			  class="WidgetlineChart WidgetlineChartshadow mb-2"
			>
			  <x-chartist class="height-75"> </x-chartist>
			</div>
		  </div>
		</div>
	  </div>
	  <div class="col-xl-3 col-lg-6 col-md-6 col-12">
		<div class="card gradient-king-yna">
		  <div class="card-content">
			<div class="card-body py-0">
			  <div class="media pb-1">
				<div class="media-body white text-left">
				  <h3 class="font-large-1 white mb-0">{{ courseCount }}</h3>
				  <span>Total Course</span>
				</div>
				<!-- <div class="media-right white text-right">
					  <i class="ft-credit-card font-large-1"></i>
					</div> -->
			  </div>
			</div>
			<div
			  id="Widget-line-chart"
			  class="WidgetlineChart WidgetlineChartshadow mb-2"
			>
			  <x-chartist
				class="height-75"
				[type]="WidgetlineChart3.type"
				[options]="WidgetlineChart3.options"
				[responsiveOptions]="WidgetlineChart3.responsiveOptions"
				[events]="WidgetlineChart3.events"
			  >
			  </x-chartist>
			</div>
		  </div>
		</div>
	  </div>
	</div>
	<!-- Section 7 -->
	<div class="row" *ngIf="guideline_section7 && guideline_section7.length > 0">
	  <div
		class="col-xl-4 col-md-4 col-12"
		*ngFor="let item of guideline_section7"
	  >
		<div class="card">
		  <div class="card-header">
			<h4 class="card-title">{{ item?.title }}</h4>
		  </div>
		  <div class="card-content">
			<div class="card-body cursor-pointer" (click)="gotoLink(item?.link)">
			  <div class="carousel-caption">
				<h3 class="ff-serif text-uppercase text-white">
				  {{ item?.name }}
				</h3>
				<p class="mb-0">{{ item?.description }}</p>
			  </div>
			</div>
		  </div>
		</div>
	  </div>
	</div>
	<!-- Section 8 -->
  
	<div class="card-content">
	  <div class="card-body section8">
		<!-- Nav Pills -->
		<ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
		  <li
			class="nav-item"
			role="presentation"
			*ngFor="let section of data_section8; let i = index"
		  >
			<a
			  class="nav-link"
			  [class.active]="activeTab === section.label"
			  (click)="setActiveTab(section)"
			  role="tab"
			>
			  {{ section.label }}
			</a>
		  </li>
		</ul>
  
		<!-- Tab Content -->
		<div class="tab-content" id="pills-tabContent">
		  <div
			class="tab-pane fade"
			*ngFor="let section of data_section8"
			[class.show]="activeTab === section.label"
			[class.active]="activeTab === section.label"
			role="tabpanel"
		  >
			<!-- <p>{{ section.description }}</p> -->
			  <div>
				<div class="app-section">
				  <div class="col d-flex align-items-center">
					<div class="app-title">
					  <h4 class="app-title-h4">
						{{app?.title}}
					  </h4>
					</div>
					<!-- <div>
					  <p placement="top" ngbTooltip="Updated Date">{{app?.updated_at | date:'mediumDate'}}</p>
					</div> -->
				  
			  
				  </div>
				  <div *ngIf="app?.type === 'image'">
					<!-- Display image content -->
					<img width="100%" [src]="s3MediaUrl+app?.content" alt="Image" />
				  </div>
				  <div *ngIf="app?.type === 'video'&&!app.isurl_link">
					<!-- Display video content -->
					<video width="100%" [src]="s3MediaUrl+app?.content" controls></video>
				  </div>
				  <div *ngIf="app?.type === 'video'&& app.isurl_link ">
					<!-- Display video content -->
					<div [innerHTML]="app.url_link | safeHtml"></div>
					<!-- {{formatHtmlapp?.url_link }} -->
				  </div>
				  <div *ngIf="app?.type === 'text'">
					<!-- Display markdown text content -->
					<div [innerHTML]="app?.content | safeHtml"></div>
				  </div>
				  <!-- <div>
					<i [ngClass]="isConnected(app?._id)?'fa fa-x cursor':'fa fa-link cursor'" title="Disconnect app"
					  (click)="connectDisconnect(app?._id)"></i>
					<i class="fa fa-edit cursor ml-2" data-toggle="modal" data-target="#app-model" (click)="editApp(app)"></i>
				  </div> -->
			  
				  <div class="row p-2" *ngIf="app?.resources">
					<div class="btn btn-outline-primary ml-2" *ngFor="let resource of app.resources">
					  <a [href]="s3MediaUrl+resource.documents" target="_blank">{{resource?.content}}</a>
					  <i class="fa fa-x cursor danger font-large float-right"></i>
					</div>
				  </div>
			  
				</div>
			  </div>
		  </div>
		</div>
	  </div>
	</div>
  </div>
  
  <!-- === -->
  <!-- Task Modal -->
  <div>
	<ng-template #taskModal let-modal>
	  <div class="modal-header">
		<h4 class="modal-title">Tasks</h4>
		<button type="button" class="close" (click)="modal.dismiss()">
		  <span>&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<fieldset  class="form-group">
			<label>Current Task</label>
			<textarea name="current-task" id="current-task" [(ngModel)]="tasks.current_task" [ngModelOptions]="{ standalone: true }" class="form-control" rows="6"></textarea>
		</fieldset>
		<fieldset  class="form-group">
			<label>Next Task</label>
			<textarea name="next-task" id="next-task" [(ngModel)]="tasks.next_task" [ngModelOptions]="{ standalone: true }" class="form-control" rows="6"></textarea>
		</fieldset>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-primary" (click)="updateTask()">Submit</button>
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
		</div>
	</ng-template>
  </div>